import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Alert,
    Typography,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import kidsImage from '../../assets/images/kids_avatar.png';
import adultImage from '../../assets/images/adult_avatar.png';

const GameDialog = ({ open, onClose, game, onSuccess }) => {
    const [name, setName] = useState('');
    const [theme, setTheme] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (game) {
            setName(game.name || '');
            setTheme(game.theme || 'kids');
        }
    }, [game]);

    const handleSubmit = async () => {
        try {
            const payload = { name, theme };
            await RequestService.updateGame(game.id, payload);
            onSuccess('Jogo alterado com sucesso!');
            onClose();
        } catch (err) {
            setError('Failed to update game. Please try again.');
        }
    };

    const ThemeOption = ({ label, value, imgSrc }) => {
        const selected = theme === value;

        return (
            <Box
                onClick={() => setTheme(value)}
                sx={{
                    cursor: 'pointer',
                    border: selected
                        ? '2px solid #1976d2'
                        : '2px solid transparent',
                    borderRadius: 2,
                    padding: 2,
                    textAlign: 'center',
                    width: '100%',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                }}
            >
                <img
                    src={imgSrc}
                    alt={label}
                    style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'contain',
                    }}
                />
                <Typography
                    sx={{ fontWeight: selected ? 'bold' : 'normal', mt: 1 }}
                    variant="body2"
                >
                    {label}
                </Typography>
            </Box>
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Editar Jogo</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Game Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                    />
                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                        Escolha o tema:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <ThemeOption
                            label="Kids"
                            value="kids"
                            imgSrc={kidsImage}
                        />
                        <ThemeOption
                            label="Adult"
                            value="adult"
                            imgSrc={adultImage}
                        />
                    </Box>
                    {error && <Alert severity="error">{error}</Alert>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                >
                    Salvar Alterações
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GameDialog;
